import React, { useState } from 'react';
import { Link, navigate } from '@reach/router';
import { auth, signInWithGoogle } from '../../firebase/firebase';
import {
  Box,
  Button,
  Toast,
  Container,
  Text,
  TextField,
  Heading,
} from 'gestalt';
import 'gestalt/dist/gestalt.css';

const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const signInWithEmailAndPasswordHandler = (event, email, password) => {
    auth.signInWithEmailAndPassword(email, password).catch(error => {
      setError("خطأ في تسجيل الدخول بكلمة المرور والبريد الإلكتروني!");
      console.error("Error signing in with password and email", error);
    });
  };

  return (
    <div>
      <Box padding={3}>
        <Container>
          <Box padding={3}>
            {error !== null && <Toast text={error} />}
            <Heading size="md">تسجيل</Heading>
          </Box>
          <Box padding={2}>
            <TextField
              id="email"
              onChange={event => setEmail(event.value)}
              placeholder="أدخل بريدك الإلكتروني"
              label="البريد الإلكتروني"
              value={email}
              type="email"
            />
          </Box>
          <Box padding={2}>
            <TextField
              id="password"
              onChange={event => setPassword(event.value)}
              placeholder="أدخل كلمة المرور الخاصة بك"
              label="كلمه المرور"
              value={password}
              type="password"
            />
          </Box>
          <Box padding={2}>
            <Button
              onClick={event => {
                signInWithEmailAndPasswordHandler(event, email, password);
                navigate('/');
              }}
              text="تسجيل الدخول"
              color="blue"
              inline
            />
          </Box>

          <Box padding={2}>
            <Text>أو يمكنك</Text>
          </Box>
          <Box padding={2}>
            <Button onClick={signInWithGoogle} text="تسجيل الدخول بحساب جوجل" color="red" inline />
          </Box>
          <Box padding={2}>
            <Text>ليس لديك حساب؟</Text>
          </Box>
          <Box padding={2}>
            <Link to="signUp" className="text-blue-500 hover:text-blue-600">
            سجل هنا
            </Link>
          </Box>
          <Box padding={2}>
            <Link
              to="passwordReset"
              className="text-blue-500 hover:text-blue-600"
            >
              هل نسيت كلمة السر؟
            </Link>
          </Box>
        </Container>
      </Box>
    </div>
  );
};
export default SignIn;
